import { Outlet } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import FloatingButton from './components/FloatingButton';

function App() {
  return (
    <div className="overflow-hidden no-scrollbar">
      <Navbar />
      <Outlet />
      <FloatingButton />
    </div>
  );
}

export default App;
